module.exports = __webpack_public_path__ + "static/media/Anugunj.2ab413c1.jpg";